// extracted by mini-css-extract-plugin
export default {"containerSection":"style-module--containerSection--fe7e6","restrictedErrorCode":"style-module--restrictedErrorCode--370ce","actionButton":"style-module--actionButton--8f103"};